// extracted by mini-css-extract-plugin
module.exports = {"toggle":"DarkModeToggle-module--toggle--2FzWu"};